// extracted by mini-css-extract-plugin
module.exports = {"xs":"Icon_xs__AfinG","s":"Icon_s__rqnIt","m":"Icon_m__zZnS1","l":"Icon_l__c7RmU","xl":"Icon_xl__ka5wt"};